import toast from '@/modules/toast/services';
import { toArray } from '@/utils';

export default {
  mounted() {
    if (typeof this.filters === 'undefined') {
      throw new Error('allowed-boards-only mixin requires a `filters` attribute.');
    }
  },
  methods: {
    filterAllowedBoards(board, notifyMessage = null) {
      const behaviour = toArray(this.filters.behaviour);
      if (!board
        || behaviour.length === 0) {
        return board;
      }
      if (!behaviour.includes(board.behaviour)) {
        if (notifyMessage) {
          toast.notify(notifyMessage);
        }
        return null;
      }
      return board;
    },
  },
};
